/**
 * editor2/modals/MemoBlockEditModal.tsx
 * 個別メモブロック編集ダイアログ
 */
import React, { useState, useEffect } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
} from '@mui/material';
import type { MemoBlock } from '../types';

interface MemoBlockEditModalProps {
  open: boolean;
  block: MemoBlock | null;
  onSave: (newContent: string) => void;
  onCancel: () => void;
}

export default function MemoBlockEditModal({
  open,
  block,
  onSave,
  onCancel,
}: MemoBlockEditModalProps) {
  const [content, setContent] = useState('');

  useEffect(() => {
    if (block) {
      setContent(block.content);
    }
  }, [block]);

  if (!block) return null;

  const title =
    block.type === 'event' ? `${block.title ?? ''} (${block.time ?? ''})` : 'メモ';

  return (
    <Dialog
      open={open}
      onClose={onCancel}
      maxWidth="sm"
      fullWidth
      PaperProps={{ style: { borderRadius: 12 } }}
    >
      <DialogTitle sx={{ fontWeight: 700 }}>{title}を編集</DialogTitle>
      <DialogContent dividers>
        <TextField
          fullWidth
          multiline
          rows={6}
          variant="outlined"
          value={content}
          onChange={(e) => setContent(e.target.value)}
          sx={{ mt: 1, '& .MuiOutlinedInput-root': { borderRadius: 2 } }}
        />
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onCancel} color="inherit">
          キャンセル
        </Button>
        <Button onClick={() => onSave(content)} variant="contained" disableElevation>
          保存
        </Button>
      </DialogActions>
    </Dialog>
  );
}
